module.exports = __webpack_public_path__ + "media/price_bot/chatButtonDisabled-c220f6e2.svg";